<div class="risk-card" data-cy="graph-risk">
	<h3 class="title">Risk Over Last 30 Days</h3>

	<ng-container *ngIf="loading; else dataOrEmptyTemplate">
		<div class="flex  justify-content-center my-5 custom-card">
			<div class="bg-blue-50 p-3 text-center rounded text-gray-800">
				Loading...
			</div>
		</div>
	</ng-container>

	<ng-template #dataOrEmptyTemplate>
		<ng-container *ngIf="hasData; else emptyStateTemplate">
			<p-chart
				[data]="chartData"
				[options]="chartOptions"
				style="width: 100%; height: 300px"
				type="line"
			></p-chart>
		</ng-container>
	</ng-template>

	<ng-template #emptyStateTemplate>
		<div *ngIf="!loading" class="flex bg-white justify-content-center my-5 custom-card">
			<div class="bg-blue-50 p-3 text-center rounded text-gray-800">
				{{
					errorStatus === 403
						? 'No AI enabled tasks available'
						: 'No data available for the selected date range'
				}}
				<div class="pt-1">
				<a
					href="mailto:support@tyalls.com"
					*ngIf="errorStatus === 403"
					class="text-primary cursor-pointer ml-1"
				>
					To enable AI Tasks contact support&#64;tyalls.com
				</a>
				</div>
			</div>
		</div>
	</ng-template>


</div>
